import { useEffect, useRef, useState } from 'react';
import { fetchContainingCity, type ContainingCity } from '../api/cities';

const SNAP_DEGREES = 0.0005;

function snap(value: number): number {
  return Math.round(value / SNAP_DEGREES) * SNAP_DEGREES;
}

export function useContainingCity(
  position: { latitude: number; longitude: number } | null,
): ContainingCity | null {
  const [city, setCity] = useState<ContainingCity | null>(null);
  const lastCheckedRef = useRef<{ lat: number; lng: number } | null>(null);

  const lat = position?.latitude ?? null;
  const lng = position?.longitude ?? null;

  useEffect(() => {
    // console.log('[cabin] containing-city: effect fired, lat/lng =', lat, lng);
    if (lat === null || lng === null) return;

    const snappedLat = snap(lat);
    const snappedLng = snap(lng);
    const last = lastCheckedRef.current;
    if (last && last.lat === snappedLat && last.lng === snappedLng) {
      // console.log('[cabin] containing-city: skipping (same snap)', snappedLat, snappedLng);
      return;
    }
    lastCheckedRef.current = { lat: snappedLat, lng: snappedLng };

    let cancelled = false;
    // console.log('[cabin] containing-city: looking up', lat, lng);
    fetchContainingCity(lat, lng)
      .then((c) => {
        if (cancelled) return;
        // console.log('[cabin] containing-city: result', c);
        setCity((prev) => {
          if (prev?.city_id === c?.city_id) return prev;
          return c;
        });
      })
      .catch((err: unknown) => {
        console.warn('[cabin] containing-city lookup failed', err);
      });

    return () => {
      cancelled = true;
    };
  }, [lat, lng]);

  return city;
}
